<template>
    <div class="o-dashboard">
        <c-agenda @create-new-request="createRequest" class="o-dashboard__table-accounts c-table--wrap c-table--agenda margin-t-56"
                  :endpoint="'/api/requests/workload/'"
        ></c-agenda>
        <c-request
            :data="modalData"
            v-show="modal"
            @close="closeModal">
        </c-request>
    </div>

</template>

<script>
import CAgenda from '@components/agenda/Container';
import View from '@mixins/View';
import CRequest from '@app/modals/Request';

export default {
    components: { CAgenda, CRequest },
    mixins: [ View ],
    data(){
        return {
            modal: false,
            modalData: undefined
        }
    },
    methods: {
        createRequest(data) {
            this.modalData = data;
            this.modal = true;
        },
        closeModal(){
            this.modalData = undefined;
            this.modal = false;
        }
    }
}
</script>
